module.exports = __webpack_public_path__ + "img/icon-warning-red.ab19e33e.svg";